import type { TemplatesV2Response, FilteredTemplate } from './types.tsx';

const NUM_TEMPLATES_TO_DISPLAY = 4;
const NUM_TEMPLATES_TO_DISPLAY_NEW = 5;
const MADE_FOR_YOU_CATEGORY = 'made-for-you-category';

// note: these 4 templates are hardcoded for the time being
const TEMPLATE_KEYS = new Set([
	'jwm.blank-project',
	'jwm.project-management',
	'jwm.personal-task-planner',
	'jwm.task-tracking',
]);

export const getFilteredTemplates = (response: TemplatesV2Response) => {
	const {
		templates,
		lastUsedTemplate: lastUsedTemplateKey,
		recommendedTemplate: recommendedTemplateKey,
	} = response;
	const lastUsedTemplates: FilteredTemplate[] = [];
	const recommendedTemplates: FilteredTemplate[] = [];
	const additionalTemplates: FilteredTemplate[] = [];

	templates.forEach((template) => {
		const { projectTypeTemplates, key, categoryTypes } = template;
		if (
			lastUsedTemplateKey != null &&
			(projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey ||
				projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey)
		) {
			lastUsedTemplates.push({ ...template, isLastUsed: true });
		} else if (
			recommendedTemplateKey != null &&
			(projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey ||
				projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey ||
				categoryTypes.includes(MADE_FOR_YOU_CATEGORY))
		) {
			recommendedTemplates.push({ ...template, isRecommended: true });
		} else if (TEMPLATE_KEYS.has(key)) {
			additionalTemplates.push(template);
		}
	});

	// templates are sorted in order of last used, recommended and fallback.
	// only use the first 4 templates
	const filteredTemplates = [
		...lastUsedTemplates,
		...recommendedTemplates,
		...additionalTemplates,
	].slice(0, NUM_TEMPLATES_TO_DISPLAY);

	return filteredTemplates;
};

export const getFilteredTemplatesNew = (response: TemplatesV2Response) => {
	const {
		templates,
		lastUsedTemplate: lastUsedTemplateKey,
		recommendedTemplate: recommendedTemplateKey,
		recommendedTemplates: recommendedTemplateKeys,
	} = response;
	const lastUsedTemplates: FilteredTemplate[] = [];
	const recommendedTemplates: FilteredTemplate[] = [];
	const additionalTemplates: FilteredTemplate[] = [];

	recommendedTemplateKeys?.forEach((key, index) => {
		const template = templates.find((t) => t.key === key);

		if (template) {
			const { projectTypeTemplates } = template;

			// * The first recommended template will be the last used template if there is one
			if (index === 0 && lastUsedTemplateKey) {
				const isLastUsed =
					lastUsedTemplateKey &&
					(projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey ||
						projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey);

				lastUsedTemplates.push({ ...template, ...(isLastUsed && { isLastUsed }) });

				return;
			}

			const isRecommended =
				recommendedTemplateKey &&
				(projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey ||
					projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey);

			recommendedTemplates.push({
				...template,
				...(isRecommended && { isRecommended }),
			});
		}
	});

	// * If there are not enough templates to display, add additional templates
	if (lastUsedTemplates.length + recommendedTemplates.length < NUM_TEMPLATES_TO_DISPLAY) {
		// * Get the keys of the templates that are not last used or recommended
		const placeholderTemplateKeys = Array.from(TEMPLATE_KEYS).filter(
			(key) =>
				!lastUsedTemplates.some((t) => t.key === key) &&
				!recommendedTemplates.some((t) => t.key === key),
		);

		templates.forEach((template) => {
			if (placeholderTemplateKeys.includes(template.key)) {
				additionalTemplates.push(template);
			}
		});
	}

	// templates are sorted in order of last used, recommended and fallback.
	// only use the first 5 templates
	const filteredTemplates = [
		...lastUsedTemplates,
		...recommendedTemplates,
		...additionalTemplates,
	].slice(0, NUM_TEMPLATES_TO_DISPLAY_NEW);

	return filteredTemplates;
};
